var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChicken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20280_303445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 0H0V500H500V0Z",
    fill: "#DDB19E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.8 500C155.8 462 239.9 450.2 263.7 406.3C323.9 295.2 397 295.6 500 305.3V500H143.8Z",
    fill: "#DCC0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 212.8V0H500V82.6C400.3 169 261.7 81.8 0 212.8Z",
    fill: "#DCC0AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M257.2 408.1C349.929 408.1 425.1 377.073 425.1 338.8C425.1 300.527 349.929 269.5 257.2 269.5C164.471 269.5 89.3 300.527 89.3 338.8C89.3 377.073 164.471 408.1 257.2 408.1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7999 263.8C93.2999 214.8 174.5 182.7 257.3 182.7C340.1 182.7 421.3 214.8 442.8 263.8C470.7 327.5 391.6 395.2 257.3 395.2C123 395.2 43.7999 327.5 71.7999 263.8Z",
    fill: "#A6A5C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7999 256.2C93.2999 207.2 174.5 175.1 257.3 175.1C340.1 175.1 421.3 207.2 442.8 256.2C470.7 319.9 391.6 387.6 257.3 387.6C123 387.7 43.7999 320 71.7999 256.2Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.6 255.4C153.2 224.3 204.7 204 257.2 204C309.7 204 361.2 224.4 374.8 255.4C392.5 295.8 342.3 338.8 257.2 338.8C172.1 338.8 121.9 295.9 139.6 255.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.3 112.5C177.6 84.9001 242.3 67.2001 299.1 82.6001C321.1 88.4001 341.1 100.1 358.3 114.7C369.8 124.3 380.3 135.3 388.5 148.2C457.7 260.9 258.3 365.6 176.3 404.5C163.6 410.5 150.9 416.2 137.7 421.5C134.9 422.7 131.6 421.3 130.5 418.5C129.4 415.7 130.7 412.5 133.4 411.3C146 405.8 158.6 399.7 171 393.5C243 357.3 452.9 241 358.5 145.1C340.6 126.9 318.2 112.1 293 106.6C254.7 97.9001 214.6 106.8 178.8 121.7C166.8 126.8 155 132.5 144 139.4C136.6 144.3 126.6 142.1 121.9 134.7C117 127.2 119.5 117 127.3 112.5Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.4 272.3C391.2 364.1 200 314.5 178.6 311.1C158 307.8 149.7 297.3 149 277.8C148.7 270.7 149.4 262.4 151 252.7C157 215.1 259.8 179.4 322.4 172.7C365.1 168.2 394 217.9 399.5 243.5C401.8 254.4 402.3 264 401.4 272.3Z",
    fill: "#B1511E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.4 272.3C391.2 364.1 200 314.5 178.6 311.1C158 307.8 149.7 297.3 149 277.8C155.8 274.6 166.3 273.8 183.7 276.2C183.7 276.2 302.6 290.2 355.2 280C373.5 276.4 389 273.9 401.4 272.3Z",
    fill: "#A0441C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.3 265C171.1 259.9 166.7 255.9 161.6 256.2C147.1 257.2 120.4 257.8 116.2 248.9C110.4 236.6 76.7999 241.8 82.4999 260.5C87.1999 276.1 98.3999 272.4 98.5999 278C98.7999 283.5 87.5999 285.7 87.8999 293.6C88.1999 301.5 98.2999 321 111.4 310.3C124.5 299.6 115.4 302.6 129.2 294.2C138.4 288.6 154.4 285.4 164 283.9C168.6 283.2 171.9 279.2 171.7 274.6L171.3 265Z",
    fill: "#E2BF8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.3 232.6C230.768 232.6 235.2 228.168 235.2 222.7C235.2 217.232 230.768 212.8 225.3 212.8C219.832 212.8 215.4 217.232 215.4 222.7C215.4 228.168 219.832 232.6 225.3 232.6Z",
    fill: "#A0441C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.2 212.8C331.668 212.8 336.1 208.368 336.1 202.9C336.1 197.432 331.668 193 326.2 193C320.732 193 316.3 197.432 316.3 202.9C316.3 208.368 320.732 212.8 326.2 212.8Z",
    fill: "#A0441C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.3 242.5C290.768 242.5 295.2 238.068 295.2 232.6C295.2 227.132 290.768 222.7 285.3 222.7C279.832 222.7 275.4 227.132 275.4 232.6C275.4 238.068 279.832 242.5 285.3 242.5Z",
    fill: "#A0441C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20280_303445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChicken);
export default __webpack_public_path__ + "static/media/Chicken.864509d2.svg";
export { ForwardRef as ReactComponent };